import { render } from "./faqView.vue?vue&type=template&id=5b9cbb9b"
import script from "./faqView.vue?vue&type=script&lang=js"
export * from "./faqView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__